// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * To Check if date is valid, and it's not black out date
 * @param blackOutDays
 * @param currentDate
 */
export function isValidDate(blackOutDays: string[], currentDate: Date) {
    const todayDate = new Date();
    return (
        currentDate.getDay() !== 0 &&
        currentDate.getDay() !== 6 &&
        !blackOutDays.find((item: string) => new Date(item).toDateString() === currentDate.toDateString()) &&
        currentDate.getTime() > todayDate.getTime()
    );
}

/**
 *
 * @param date your date input
 * @returns YYYY-MM-DD formatted date
 */
export const getFormattedDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${month}-${day}-${year}`;
};

export const parseDate = (date: string | null | undefined) => {
    if (!date) {
        return "";
    }
    const substr = date.substring(0, date.indexOf("T"));
    return getUTCDate(new Date(substr));
};

export const getUTCDate = (date: Date) => {
    const fullYear = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();

    return `${month < 10 ? `0${month}` : month}/${day}/${fullYear}`;
};

export const comparePublishDate = (date: string) => {
    const publishDate = new Date(date).getTime();
    return publishDate <= new Date().getTime();
};

export const compareExpirationDate = (date: string) => {
    const expirationDate = new Date(date).getTime();
    return expirationDate > new Date().getTime();
};
